// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._v5641dtu{transition:var(--_178jgwx)}", ""]);
// Exports
module.exports = exports;
